import { useState, useEffect, createContext, useCallback } from 'react';
import { useParams } from 'react-router-dom';
import PropTypes from 'prop-types';

import { cardAPI } from '../apis/cardAPI';
import { useSet } from '../hook/useSet';

export const CardContext = createContext(null);

export const CardProvider = ({ children }) => {
	const params = useParams();

	const [cards, setCards] = useState({});
	const [loadingCards, setLoadingCards] = useState(false);
	const [activeCard, setActiveCard] = useState(null);
	const [filter, setFilter] = useState({
		set_code: [],
		name: '',
	});

	const { sets, activeSet } = useSet();

	useEffect(() => {
		console.log('Initialization: CardProvider');
	}, []);

	const applyFilter = useCallback((filterUpd) => {
		setFilter(filterUpd);
		setLoadingCards(true);
		cardAPI.getCards(filterUpd).then((resp) => {
			let cardsUpd = {};
			for (let i = 0; i < resp.cards.length; i++) {
				cardsUpd[resp.cards[i].id] = resp.cards[i];
			}
			setCards(cardsUpd);
			setLoadingCards(false);
		});
	}, []);

	useEffect(() => {
		if (activeSet) {
			let filterUpd = {};
			filterUpd.set_code = [activeSet.code];
			filterUpd.name = '';
			applyFilter(filterUpd);
		}
	}, [sets, activeSet, applyFilter]);

	useEffect(() => {
		if (params.card_id in cards) {
			setActiveCard(cards[params.card_id]);
		}
	}, [cards, params.card_id]);

	// Search card by collector number
	function searchCard(setCode, collectorNumber, onResult) {
		cardAPI.searchCard(setCode, collectorNumber).then((resp) => {
			if (resp.card) {
				onResult(true, resp.card);
			} else {
				onResult(false, resp.message);
			}
		});
	}

	const value = {
		cards,
		loadingCards,
		activeCard,
		filter,
		setFilter, // set without reload card
		applyFilter, // set with cards reload
		searchCard,
		setActiveCard,
	};

	return <CardContext.Provider value={value}>{children}</CardContext.Provider>;
};

CardProvider.propTypes = {
	children: PropTypes.node.isRequired,
};
